module.exports = __webpack_public_path__ + "static/img/bi-icon.d0b4a53c.gif";